import { useState } from 'react';
import { Share2, Copy, ExternalLink, Loader2 } from 'lucide-react';
import { toast } from 'sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const ShareReadButton = ({ readId }) => {
  const [link, setLink] = useState(null);
  const [loading, setLoading] = useState(false);

  const create = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/share-cards`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ read_id: readId }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.detail || 'Could not create share link');
      setLink(`${window.location.origin}/api/s/${data.card_id}`);
    } catch (e) { toast.error(e.message); } finally { setLoading(false); }
  };

  const copy = async () => {
    try { await navigator.clipboard.writeText(link); toast.success('Link copied'); } catch { toast.error('Copy not available. Select the link instead.'); }
  };

  if (!readId) return null;
  return (
    <div className="mt-6 bg-zinc-950 border border-zinc-800 rounded-lg p-5" data-testid="share-read-section">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <div>
          <p className="font-bold text-sm">Share this read</p>
          <p className="text-xs text-zinc-500">Create a branded card link to send to a friend or colleague.</p>
        </div>
        {!link && (
          <button onClick={create} disabled={loading} data-testid="share-read-btn"
            className="bg-brand hover:bg-brand-light text-black text-xs font-bold px-4 py-2 rounded-md inline-flex items-center gap-1.5 transition-colors disabled:opacity-50">
            {loading ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Share2 className="w-3.5 h-3.5" />} Create share card
          </button>
        )}
      </div>
      {link && (
        <div className="mt-4 flex flex-col sm:flex-row gap-2" data-testid="share-link-box">
          <input readOnly value={link} onFocus={(e) => e.target.select()} data-testid="share-link-input"
            className="flex-1 bg-black border border-zinc-800 rounded-md px-3 py-2 text-xs font-mono text-zinc-300" />
          <button onClick={copy} data-testid="share-copy-btn" className="text-xs border border-zinc-700 hover:border-brand/60 text-zinc-300 px-3 py-2 rounded-md inline-flex items-center justify-center gap-1.5">
            <Copy className="w-3.5 h-3.5" /> Copy
          </button>
          <a href={link} target="_blank" rel="noopener noreferrer" data-testid="share-open-link" className="text-xs border border-zinc-700 hover:border-brand/60 text-zinc-300 px-3 py-2 rounded-md inline-flex items-center justify-center gap-1.5">
            <ExternalLink className="w-3.5 h-3.5" /> Open card
          </a>
        </div>
      )}
    </div>
  );
};
